import React from "react"
import ReactMarkdown from "react-markdown"

export default function MarkdownText({ content }: { content: string | null }) {
  if (!content?.trim()) {
    return null
  }

  return (
    <ReactMarkdown
      components={{
        a: MarkdownHtmlA,
      }}
    >
      {content}
    </ReactMarkdown>
  )
}

function MarkdownHtmlA({
  children,
  ...props
}: React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  node?: unknown
}) {
  return (
    <a {...props} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  )
}
